export default __webpack_public_path__ + "static/media/mc.18b2c7d8.svg";